import * as type from '../constants/prospect';

export function createProspects(values, actions) {

    return {
        type: type.CREATE_PROSPECTS,
        values,
        actions,
    };
}

export function createProspectsSuccess(success) {

    return {
        type: type.CREATE_PROSPECTS_SUCCESS,
        success,
    };
}

export function createProspectsFailure(error) {

    return {
        type: type.CREATE_PROSPECTS_FAIL,
        error,
    };
}

export function clearProspect() {

    return {
        type: type.CLEAR_PROSPECT,
    };
}

export function getQuestions(values, actions) {
    return {
        type: type.GET_QUESTIONS,
        values,
        actions,
    };
}

export function getRegisterData(values, actions) {

    return {
        type: type.GET_REGISTER_DATA,
        values,
        actions,
    };
}

export function getRegisterDataSuccess(registerData) {
    return {
        type: type.GET_REGISTER_DATA_SUCCESS,
        registerData,
    };
}

export function getRegisterDataFailure(error) {

    return {
        type: type.GET_REGISTER_DATA_FAIL,
        error,
    };
}